import axiosInstance from '../../../../config/axiosInstance';
import BASE_URL from '../../../../config/config';
const  HelpLinkService = {
    async GetAllHelpLinks(redirectCallback) {
        try {            
            
            const token = localStorage.getItem('token');
            if (!token || token=="null") {
                
                redirectCallback();
                return; // Return early to prevent further execution
              }
            const ClientID=localStorage.getItem('CompanyID');
           
            const response = await axiosInstance.get(`${BASE_URL}/SuperAdmin/GetHelpLink`);
           
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteHelpLink(ID,redirectCallback) {
        try {
            debugger;
            const token = localStorage.getItem('token');
            if (!token || token == "null") {

                redirectCallback();
                return; // Return early to prevent further execution
            }
           
            const response = await axiosInstance.get(`/SuperAdmin/DeleteHelpLink?ID=${ID}`);
           
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default HelpLinkService;